module.exports = __webpack_public_path__ + "img/c6e4615.svg";